import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConversionProvider } from "@/context/ConversionContext";
import { CookieProvider } from "@/context/CookieContext";
import { getStoredLang } from "@/context/LanguageContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import CategoryHub from "@/pages/CategoryHub";
import ServicePage from "@/pages/ServicePage";
import Frontaliers from "@/pages/Frontaliers";
import About from "@/pages/About";
import Partners from "@/pages/Partners";
import Conseils from "@/pages/Conseils";
import Article from "@/pages/Article";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <CookieProvider>
      <ConversionProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to={`/${getStoredLang()}`} replace />} />
            <Route path="/:lang" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="particuliers" element={<CategoryHub category="particuliers" />} />
              <Route path="particuliers/:slug" element={<ServicePage />} />
              <Route path="professionnels-entreprises" element={<CategoryHub category="professionnels" />} />
              <Route path="professionnels/:slug" element={<ServicePage />} />
              <Route path="epargne-retraite-assurance-vie" element={<CategoryHub category="epargne" />} />
              <Route path="assurance-vie" element={<ServicePage slugProp="assurance-vie" />} />
              <Route path="per" element={<ServicePage slugProp="per" />} />
              <Route path="frontaliers" element={<Frontaliers />} />
              <Route path="a-propos" element={<About />} />
              <Route path="partenaires" element={<Partners />} />
              <Route path="conseils" element={<Conseils />} />
              <Route path="conseils/:slug" element={<Article />} />
              <Route path="contact" element={<Contact />} />
              <Route path="faq" element={<Faq />} />
              <Route path="mentions-legales" element={<Legal type="mentions" />} />
              <Route path="politique-confidentialite" element={<Legal type="privacy" />} />
              <Route path="politique-cookies" element={<Legal type="cookies" />} />
              <Route path="reclamations" element={<Legal type="complaints" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="*" element={<Navigate to={`/${getStoredLang()}`} replace />} />
          </Routes>
        </BrowserRouter>
      </ConversionProvider>
    </CookieProvider>
  );
}

export default App;
